type Dhms = {
  negative: number
  days: number
  hours: number
  minutes: number
  seconds: number
  decimals: number
}

type Options = {
  ceil?: boolean
}

/**
 * Converts milliseconds to an object containing days, hours, minutes, seconds, and optional decimal milliseconds.
 *
 * @param {number} [ms=0] - The time in milliseconds to convert. Defaults to 0.
 * @param {Object} [options={}] - The options object to customize the conversion.
 * @param {boolean} [options.ceil=true] - Whether to ceil the time calculations or floor them.
 * @return {Dhms} An object containing the converted time values: days, hours, minutes, seconds, decimals, and a negative flag.
 */
export function msToDhms(ms: number = 0, { ceil = true }: Options = {}): Dhms {
  const negative = ms < 0 ? 1 : 0
  const decimalMs = Math.abs(Math.floor(ms % 1000)) || 0
  const round = ceil ? Math.ceil : Math.floor
  const roundedMs = Math.abs(round(ms / 1000)) * 1000

  return {
    negative,
    days: Math.floor(roundedMs / 86400000) || 0,
    hours: Math.floor((roundedMs % 86400000) / 3600000) || 0,
    minutes: Math.floor((roundedMs % 3600000) / 60000) || 0,
    seconds: Math.floor((roundedMs % 60000) / 1000) || 0,
    decimals: Math.floor(decimalMs / 100),
  }
}
